export default __webpack_public_path__ + "static/media/Shortee.c0fd48e9.mp4";